import {CBTextBox} from "../../../components/common/ContentBox";
import {enrollSms, activateTotp} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useState} from "react";
import {toast} from "react-toastify";
import IconSms from "../../../../images/icon_sms.png";
import IconUser from "../../../../images/icon_user.png"
import IconError from "../../../../images/error.png"

import {AuthReButton, AuthBox, AuthContent, AuthIcon, AuthButton, AuthBack, AuthIntro} from "../../common/AuthBox";
import {useHistory} from "react-router-dom";
import {useFactors} from "../../../contexts/FactorsContext";
import {countriesList, numberList} from "./config";

const OktaEnrollOktaSms = () => {

    const [enrollStep, setEnrollStep] = useState(1);
    const [passCode, setPassCode] = useState("");
    const [factorId, setFactorId] = useState(null);
    const [selectedConCode, setSelectedConCode] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState(null);
    const [sentCode, setSentCode] = useState(null);
    const [reSendCode, setReSendCode] = useState(null);
    const [blankToken, setBlankToken] = useState(null);
    const [blankPhone, setBlankPhone] = useState(null);
    const [lastPhoneNumber, setLastPhoneNumber] = useState(null);
    const [lastConCode, setLastConCode] = useState(null);
    const history = useHistory();
    const {refresh} = useFactors();
    const enroll = async () => {
        if (!phoneNumber) {
            setBlankPhone(true);
            return;
        }
        setReSendCode(false);
        setError(false);
        setLastPhoneNumber(phoneNumber);
        setLastConCode(selectedConCode);
        const enrollOktaSmsResponse = await runApi(
            'enrollCall',
            () => enrollSms("+" + selectedConCode + phoneNumber)
        );

        if (!enrollOktaSmsResponse?.data?.status) {
            setError(true);
            setLastPhoneNumber(null);
            setLastConCode(null);
            return;
        }
        console.log(enrollOktaSmsResponse)

        if (enrollOktaSmsResponse?.data?.data?.status === 'ACTIVE') {
            toast.success("Activate sms successfully.")
            finishActivate();
            return;
        }

        setSentCode(true);
        setEnrollStep(3);
        startResendCount();
        setFactorId(enrollOktaSmsResponse?.data?.data?.id);
    }

    const startResendCount = () => {
        setTimeout(
            function () {
                setReSendCode(true);
                setSentCode(false)
            },
            30000
        );
    }

    const toStep2 = () => {
        setEnrollStep(2);
    }

    const activate = async () => {
        if (!passCode) {
            setBlankToken(true);
            return;
        }
        const activateSmsResponse = await runApi(
            'activateSmsResponse',
            () => activateTotp(factorId, passCode)
        );

        if (!activateSmsResponse?.data?.status) {
            setError(true);
            return;
        }

        toast.success("Activate OKTA sms successfully.")
        finishActivate();
    }

    const finishActivate = () => {
        refresh();
        history.push('/profile/mfa');
    }

    const getCountriesByCode = (code) => {
        const countryNumber = numberList[code];
        setSelectedConCode(countryNumber);
    }

    const handlePassCodeChange = (event) => {
        setPassCode(event.target.value);
        setBlankToken(false);
        setError(false);
    }

    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
        setBlankPhone(false);
    }

    const resend = () => {
        enroll();
    }
    return (
        <AuthBox>
            <AuthIcon src={enrollStep === 1 ? IconUser : IconSms}/>
            {enrollStep === 1 &&
            <AuthIntro Title={"SMS Authentication"} Description={"Enter a single-use code sent to your mobile phone."}
                       Icon={IconSms} nextEvent={() => toStep2()}/>}
            {(enrollStep === 2 || enrollStep === 3) &&
            <AuthContent>
                <p><strong>Receive a code via SMS to authenticate</strong></p>
                {error &&
                <div className="infobox-error clearfix">
                    <span className="error-icon"><img src={IconError} alt={"error"} width="16"/></span>
                    <p>We found some errors. Please review the form and make corrections.</p>
                </div>
                }
                {reSendCode && <div className="infobox-warning clearfix">
                    <span className="error-icon"><img src={IconError} alt={"error"} width="16"/></span>
                    <p>Haven't received an SMS? To try again, click Re-send code.</p>
                </div>}
                <form className="code-via-sms">
                    {<select className="select-city"
                             onChange={(event) => getCountriesByCode(event.target.value)}> {countriesList ? countriesList.map(function (val, idx) {
                        return <option value={val.code} selected={val.code === "US"}>{val.name}</option>;
                    }) : []}
                    </select>}
                    <label>Phone number</label>
                    <div className="phone-num clearfix">
                        <span className="city-num">+{selectedConCode}</span>
                        <input type="text" name="phone" value={phoneNumber}
                               onChange={e => handlePhoneNumberChange(e)}/>
                    </div>
                    {blankPhone && <span className="form-input-error" style={{textAlign: 'left'}}>This field cannot be left blank</span>}
                    {reSendCode && lastPhoneNumber === phoneNumber && lastConCode === selectedConCode &&
                    <AuthReButton buttonEvent={() => resend()} buttonText={"Re-send code"}/>}
                </form>
                {((!sentCode && !reSendCode) || (reSendCode && !(lastPhoneNumber === phoneNumber && lastConCode === selectedConCode))) &&
                <AuthButton buttonEvent={() => enroll()} buttonText={"Send Code"}/>}
                {sentCode && <AuthReButton buttonText={"Sent"}/>}
                {enrollStep === 3 && <div>
                    <form className="enter-code">
                        <label>Enter Code</label>
                        <CBTextBox disabled={false} value={passCode}
                                   onChange={e => handlePassCodeChange(e)}></CBTextBox>
                        {blankToken && <span className="form-input-error">This field cannot be left blank</span>}

                    </form>

                    <AuthButton buttonEvent={() => activate()} buttonText={"Verify"}/>
                </div>}
                <AuthBack src="/profile/mfa/enroll/OKTA/sms"/>

            </AuthContent>}
        </AuthBox>
    );
}
;

export default OktaEnrollOktaSms;
